import styled from 'styled-components';

export const MakeModelsSelectionStyled = styled.div`
  .makeModelsSelection {
    &__advancedFilters {
      margin-bottom: 16px;
      .leftFiltersContainer {
        &__leftFilter {
          display: flex;
          border-radius: 4px;
          gap: 8px;
          background-color: ${props => props.theme.uiColors.background01};
          align-items: center;
          padding: 10px;
          border: 1px solid ${props => props.theme.uiColors.wizardTargetingSubsectionBorder};
          span {
            font-size: ${props => props.theme.fontSizeXS};
            white-space: nowrap;
            color: ${props => props.theme.uiColors.wizardTargetingSubsectionDisclaimer};
            margin-right: 12px;
          }
        }
      }
    }
    &__loading {
      padding: 12px;
      &Content {
        margin-top: 8px;
        margin-bottom: 16px;
      }

      &Pagination {
        margin: 24px 0;
      }
    }
    &__tableContainer { // todo delete all of this custom styles whenever needed
      overflow: hidden;
      box-sizing: border-box;
      &__tableData {
        table {
          min-height: 360px;
          box-sizing: border-box;
          padding: 12px;
          background-color: ${props => props.theme.uiColors.background01};
        }
        .listTbodyRow {
          font-family: ${props => props.theme.fontRegular};
        }
        .compactPagination {
          background-color: ${props => props.theme.uiColors.background01};
        }
      }
      .makeModelEntry {
        &__make {
          font-size: ${props => props.theme.fontSizeXXS};
          color: ${props => props.theme.uiColors.deviceMake};
        }
      }
      .listTbody__groupItems {
        align-items: center;
      }
    }
  }
`;
